import React, { useState, useRef, useEffect } from 'react'
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'
import './Location.css'
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getLocationById } from '../../redux/api/locationApi/LocationApi';


export default function () {
    const [client, setClient] = useState([]);
    const clientData = useSelector((state) => state.utils.clientList || []);
    const location = useLocation();
    const id = location.state?.ROWID || "";
    const [locations, setLocations] = useState(null);
    useEffect(() => {
        console.log({ location })
        console.log({ id })
        getLocationById(id).then((response) => {
            if (response.data.success) {
                setLocations(response.data.locationsData);
            }
        }).catch((error) => {
            console.log({ error });
        });
    }, [id]);

    useEffect(() => {
        console.log({ locations })
    }, [locations])

    //for adding scrollbar in tablist
    const tabListRef = useRef(null);
    const [touchStartX, setTouchStartX] = useState(0);
    const [touchEndX, setTouchEndX] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const handleTouchStart = (e) => {
        setTouchStartX(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEndX(e.touches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (tabListRef.current) {
            const distance = touchStartX - touchEndX;

            if (distance > 50) {
                // Swipe left to scroll right
                tabListRef.current.scrollBy({ left: 100, behavior: 'smooth' });
            } else if (distance < -50) {
                // Swipe right to scroll left
                tabListRef.current.scrollBy({ left: -100, behavior: 'smooth' });
            }
        }
    };
    useEffect(() => {
        if (clientData.length > 0) {
            setClient(clientData);
        }
    }, [clientData]);

    //lookups-->
    const clientName = (id) => {
        const clientData = client.filter((item) => item.clients?.ROWID === id);
        console.log({ clientData })
        return (clientData[0]?.clients.firstName || "N/A") + " " + (clientData[0]?.clients.lastName || "")
    }
    return (
        <div >
            <Tabs variant='enclosed'>
                <TabList ref={tabListRef} className="custom-tablist" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
                    <Tab>Overview</Tab>
                </TabList>
                <TabPanels>
                    {/* Overview panel */}
                    <TabPanel className='custom-scroll'>
                        <div>
                            {/* Profile div  */}
                            <div className='wrapper card card-detail InspectionDetail mt-3'>
                                <div className='d-flex justify-content-between' style={{ marginLeft: '14px' }}>
                                    <div className='col-lg-6 col-md-12 col-7 mt-4  s locationsName'>
                                        <h4 style={{ color: "#023233" }}>{locations?.country || 'NA'}</h4>
                                        <p>Location</p>
                                    </div>
                                </div>
                            </div>
                            {/* Profile div  end */}
                            {/* Below content  */}
                            <h7 className="ps-3" style={{ color: "#767272" }}>Location Information</h7>
                            <div className="wrapper mt-1">
                                <div className="row g-3">
                                    <div className="col-lg-6 col-md-12 d-flex align-items-stretch">
                                        <div className="card card-detail p-0">
                                            <div className="card-body py-0 pe-0">
                                                <div className="table-responsive table-div1">
                                                    <table className="table table-space ">
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Country</th>
                                                            <td className='font-color'>{locations?.country}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>City</th>
                                                            <td className='font-colors'>{locations?.city}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>State</th>
                                                            <td className='font-colors'>{locations?.state}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Street</th>
                                                            <td className='font-color'>{locations?.street || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Pin Code</th>
                                                            <td className='font-colors'>{locations?.pinCode || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Client</th>
                                                            <td className='font-colors'>{clientName(locations?.client || 'NA')}</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    {/* Overview panel ends*/}
                </TabPanels>
            </Tabs>
        </div>
    )
}

